<mat-sidenav-container autosize class="sidenav-container">
  <mat-sidenav
    #sidenav
    [disableClose]="true"
    mode="side"
    class="mat-elevation-z2"
    [fixedInViewport]="true"
    [opened]="mobileQuery.matches ? 'false' : 'true'"
  >
    <mat-nav-list>
      <div class="input-form">
        <div *ngIf="isInEditMode" class="reorder-div">
          <button mat-icon-button (click)="goToReorder()">
            <!-- <mat-icon class="reorder-icon"  matTooltip="{{'components.wiki.reorder.reorderTip.fullLabel' | translate}}" matTooltipPosition="right"> -->
            <mat-icon
              class="reorder-icon"
              matTooltip="{{
                'components.wiki.reorder.reorderTip.fullLabel' | translate
              }}"
              matTooltipPosition="right"
            >
              reorder
            </mat-icon>
          </button>
        </div>
        <mat-expansion-panel class="mat-elevation-z0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <form [formGroup]="findTextForm" (ngSubmit)="onSubmit()">
                <mat-form-field>
                  <mat-label>{{
                    "components.wiki.search.fullLabel" | translate
                  }}</mat-label>
                  <input
                    matInput
                    formControlName="textToFind"
                    autocomplete="off"
                    (click)="$event.stopPropagation()"
                  />
                </mat-form-field>
                <button
                  mat-icon-button
                  type="submit"
                  (click)="$event.stopPropagation()"
                >
                  <mat-icon>search</mat-icon>
                </button>
              </form>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <span>
            <mat-checkbox
              class="right-side-checkbox"
              color="primary"
              value="title"
              [(ngModel)]="titleBool"
              (change)="changeSearchTitle()"
              >{{
                "components.wiki.searchTitle.fullLabel" | translate
              }}</mat-checkbox
            >
            <mat-checkbox
              class="right-side-checkbox"
              color="primary"
              value="content"
              [(ngModel)]="contentBool"
              (change)="changeSearchContent()"
              >{{
                "components.wiki.searchContent.fullLabel" | translate
              }}</mat-checkbox
            >
          </span>
        </mat-expansion-panel>
      </div>
      <app-side-nav-tree></app-side-nav-tree>
    </mat-nav-list>
    <!-- <ngx-simplebar>
        </ngx-simplebar> -->
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar>
      <mat-toolbar-row>
        <div class="nav-toggler">
          <button mat-icon-button (click)="sidenav.toggle()">
            <mat-icon class="menuIcon" aria-label="Menu">menu</mat-icon>
          </button>
        </div>
        <span class="title" routerLink="/smartwaste/">{{
          "components.wiki.title.fullLabel" | translate
        }}</span>
        <span class="spacer"></span>

        <div class="right-side-divs">
          <div *ngIf="isBizzDev" class="provider-select"></div>
          <div class="print-button" *ngIf="selectedDirectoryOrFilePath">
            <button (click)="printToPdf()" mat-icon-button>
              <mat-icon>picture_as_pdf</mat-icon>
            </button>
          </div>
          <div class="slide-toggle-div" *ngIf="isBizzDev">
            <mat-slide-toggle
              [(ngModel)]="isInEditMode"
              (change)="changeEditMode($event)"
            >
              <mat-label>{{
                "components.wiki.editor.edit.fullLabel" | translate
              }}</mat-label></mat-slide-toggle
            >
          </div>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
